/* eslint @typescript-eslint/ban-types: 1 */ // --> WARN
export function createFunction(expression: string): Function {
  const debugEnabled = window.__APP_CONFIG__.DEBUG_RULE_ENGINE === 'true'
  return new Function(
    'context',
    `
    var entity = context.entity
    var row = context.row
    var logic = context.logic
    var user = context.user
    var tenant = context.tenant
    ${debugEnabled ? `console.log(${JSON.stringify(expression)}, ${expression})` : ''}
    return ${expression}
  `,
  )
}
